import { ReactNode, useCallback, useSyncExternalStore } from 'react';

type Props = {
  children?: ReactNode;
};

function PcOnly({ children }: Props) {
  const { isPc } = useScreenWidth();
  if (isPc) return <>{children}</>;
  return null;
}

export default PcOnly;

function useScreenWidth() {
  const mediaQueryList = window.matchMedia(
    'screen and (min-width: 768px) and (min-height: 432px)'
  );

  const isPc = useSyncExternalStore(
    useCallback(
      (callback) => {
        mediaQueryList.addEventListener('change', callback);
        return () => mediaQueryList.removeEventListener('change', callback);
      },
      [mediaQueryList]
    ),
    useCallback(() => mediaQueryList.matches, [mediaQueryList])
  );

  return { isPc };
}
